import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import {
  setProfileModalPage,
  setProfileModalDetailPage,
  displayProfileModal,
} from '../../../modules/profile/actions/creators'

import {
  setActiveVouchers,
  setUsedVouchers,
} from '../../../modules/loyalty/actions/creators'

import VouchersPage from '../components/VouchersPage/VouchersPage'

const mapStateToProps = reduxState => {
  const { auth, profile, loyalty } = reduxState

  const { accessToken } = auth

  const {
    profileModalPage,
    profileDetailPage,
    advanceAccount,
    showProfileModal,
  } = profile

  const { activeVouchers, usedVouchers } = loyalty

  return {
    accessToken,
    profileModalPage,
    profileDetailPage,
    activeVouchers,
    usedVouchers,
    advanceAccount,
    showProfileModal,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setProfileModalPage,
      setProfileModalDetailPage,
      setActiveVouchers,
      setUsedVouchers,
      displayProfileModal,
    },
    dispatch,
  )

const ConnectedVouchersPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(VouchersPage)

export default ConnectedVouchersPage
